import React, { useEffect, useRef } from 'react';
import { Logo } from '../ds/components/Brujula';

// La brújula acompaña la página final (An, 04/11: «la brújula acompaña»): la A del logo, la misma de la apertura,
// abre cada sección y, cuando la sección aparece, gira como una aguja hasta apuntar a su título. Reemplaza a las
// volantas: guía sin sumar palabras. La punta se mide del dibujo (el punto del contorno más lejos del centro), como
// en la apertura: suponer hacia dónde apunta la A ya falló una vez. Con movimiento reducido queda quieta apuntando.
const BrujulaGuia = () => {
  const ref = useRef(null);

  useEffect(() => {
    const el = ref.current;
    const titulo = el?.nextElementSibling;
    if (!el || !titulo) return undefined;
    const r = el.getBoundingClientRect();
    const cx = r.left + r.width / 2;
    const cy = r.top + r.height / 2;
    let punta = [r.right, cy];
    let lejos = 0;
    el.querySelectorAll('path').forEach((p) => {
      const largo = p.getTotalLength?.();
      const m = p.getScreenCTM?.();
      if (!largo || !m) return;
      for (let i = 0; i <= 96; i += 1) {
        const q = p.getPointAtLength((largo * i) / 96);
        const x = m.a * q.x + m.c * q.y + m.e;
        const y = m.b * q.x + m.d * q.y + m.f;
        const d = Math.hypot(x - cx, y - cy);
        if (d > lejos) { lejos = d; punta = [x, y]; }
      }
    });
    const grados = (x, y) => (Math.atan2(y - cy, x - cx) * 180) / Math.PI;
    const t = titulo.getBoundingClientRect();
    const giro = grados(t.left + Math.min(48, t.width / 4), t.top + Math.min(t.height, 48) / 2) - grados(punta[0], punta[1]);
    const final = `rotate(${giro}deg)`;

    if (window.matchMedia?.('(prefers-reduced-motion: reduce)').matches || !el.animate) {
      el.style.transform = final;
      return undefined;
    }
    const obs = new IntersectionObserver(([e]) => {
      if (!e.isIntersecting) return;
      obs.disconnect();
      el.animate([
        { transform: 'rotate(0deg)' },
        { transform: `rotate(${giro + 28}deg)`, offset: 0.45 },
        { transform: `rotate(${giro - 9}deg)`, offset: 0.72 },
        { transform: final },
      ], { duration: 1500, easing: 'cubic-bezier(0.2, 0.8, 0.2, 1)', fill: 'forwards' });
    }, { threshold: 0.9 });
    obs.observe(el);
    return () => obs.disconnect();
  }, []);

  return <span ref={ref} className="gh-guia__a" aria-hidden="true"><Logo variante="simbolo" /></span>;
};

export default BrujulaGuia;
